module.exports = __webpack_public_path__ + "img/holding-fish.e3b27feb.jpg";